import styled from "styled-components";
import {StyledModal} from "../../../common/shared/modal.styled";

export const StyledEditApartmentPaymentsModal = styled(StyledModal)`
  .modal-close {
    color: #181818 !important;
  }
  
  .modal-header {
    color: var(--bllink-gray);
    display: flex;
    flex-direction: column;
    align-items: center;
    border-bottom: none;
    padding-top: 60px;
    padding-bottom: 0;
  }

  .day-picker {
    position: absolute;
    left: 68%;
    transform: translateX(-50%);
    bottom: 80px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  
  .modal-dialog .modal-body {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding-top: 10px;
    color: var(--bllink-gray);
    
    .confirm {
      margin: 10px 0;
    }
    
    button {
      position: relative;
      width: 200px;
      margin-top: 42px;
      
      .text {
        margin-left: 10px;
      }
      
      .circle {
        position: absolute;
        left: 10px;
        top: 50%;
        transform: translateY(-50%);
        background: #fff;
        border-radius: 50%;
        width: 30px;
        height: 30px;
        margin-right: 10px;
        
        img {
          margin-top: 2px;
          margin-right: 2px;
        }
      }
    }
    
    th {
      font-weight: normal;
      padding: 10px .5em;
      min-width: 100px;
      &.amount {
        text-align: end;
      }
      &:first-of-type {
        min-width: 0;
      }
    }
    
    tr {
      &.disabled {
        color: rgba(55, 54, 71, 0.5);
      }
    }
    
    td {
      font-weight: 700;
      padding-bottom: 13px;
      padding-inline-end: 0.5em;
      padding-inline-start: 0.5em;
      &.amount {
        text-align: end;
      }
      &:first-of-type {
        padding-bottom: 0;
      }
    }
  }
  
  .panel {
    width: 530px;
    height: 80px;
    bottom: 50px;
    position: sticky;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 8px 30px rgba(67, 57, 126, 0.1);
    z-index: 1000;
    background: #fff;
    direction: ltr;
    
    .delimiter {
      height: 50px;
      width: 1px;
      background: #DCDCE2;
    }
    
    .panel-left, .panel-right, .panel-center {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      
      .panel-close {
        cursor: pointer;
        display: block;
        font-size: 36px;
        margin-bottom: 3px;
        margin-left: 50%;
        transform: translateX(-50%);
      }
    }
    
    .panel-left {
      width: 70px;
    }
    
    .panel-center {
      justify-content: flex-end;
      font-size: 14px;
      text-align: center;
      width: 350px;
      margin-right: 20px;
      
      .tab {
        cursor: pointer;
        display: flex;
        align-items: center;
        width: 90px;
        height: 100%;
        font-weight: 700;
        margin: 0 5px;
        
        &.active, &:active {
          background: linear-gradient(355deg, rgba(243, 241, 255, 0) 3.58%, #F3F1FF 93.35%);
          color: #6E74FF;
        }
      }
    }

    .panel-right {
      text-align: center;
      color: #6E74FF;
      width: 100px;
      font-size: 14px;
      font-weight: 700;
      
      .content {
        display: flex;
        justify-content: center;
        
        .text {
          width: 80%;
          
          .num {
            font-size: 24px;
          }
        }
      }
    }
  }
`
